import { PITCH_RAIL_LABELS } from '../domain/pitchContext'

type PitchRailProps = {
  value: number | null
  onChange?: (pitchClass: number) => void
  disabled?: boolean
  label?: string
}

export function PitchRail({ value, onChange, disabled = false, label = 'Absolute pitch tonic' }: PitchRailProps) {
  const choose = (pitchClass: number) => {
    if (!disabled) onChange?.(pitchClass)
  }

  const handleKey = (event: React.KeyboardEvent<HTMLButtonElement>, pitchClass: number) => {
    if (disabled || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return
    event.preventDefault()
    const direction = event.key === 'ArrowRight' ? 1 : -1
    const next = (pitchClass + direction + PITCH_RAIL_LABELS.length) % PITCH_RAIL_LABELS.length
    onChange?.(next)
    document.querySelector<HTMLButtonElement>(`[data-pitch-stop="${next}"]`)?.focus()
  }

  return (
    <div className={disabled ? 'pitch-rail disabled' : 'pitch-rail'} role="group" aria-label={label}>
      <div className="pitch-rail-track">
        {PITCH_RAIL_LABELS.map((note, pitchClass) => {
          const selected = value === pitchClass
          return (
            <button
              className={selected ? 'pitch-stop selected' : 'pitch-stop'}
              type="button"
              key={note}
              data-pitch-stop={pitchClass}
              aria-pressed={selected}
              disabled={disabled}
              onClick={() => choose(pitchClass)}
              onKeyDown={(event) => handleKey(event, pitchClass)}
            >
              <span>{note}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
